// extracted by mini-css-extract-plugin
var _1 = "CardAddPopup_content__+hLCM";
var _2 = "CardAddPopup_dropdownMenu__aIOkb";
var _3 = "CardAddPopup_text__pHhay";
export { _1 as "content", _2 as "dropdownMenu", _3 as "text" }
